// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { BootObject_SL_abstract } from './../abstract/SagaBase/BootObject_SL_abstract';
export class BootObject_SL extends BootObject_SL_abstract {}
